/* Portals a module modal into document.body so its position:fixed overlay is relative
   to the real viewport — not a transformed ancestor. When the module renders inside the
   investor dashboard tab, ancestor elements carry CSS transforms which would otherwise
   trap a fixed overlay inside the tab (covering only part of the page). The `.dlg-dm`
   wrapper keeps the module's scoped modal styles applying at body level. */
import React from 'react';
import { createPortal } from 'react-dom';

export default function ModalPortal({ children }) {
	if (typeof document === 'undefined') return null;
	return createPortal(<div className="dlg-dm dlg-dm--modalroot">{children}</div>, document.body);
}
